Postlogin = (function (my) {
    my.Dashboard = {};
    const self = my.Dashboard;

    self.init = function () {
        initLessonAssignmentsTable();
        initAssessmentAssignmentsTable();
        initStudentsTable();
        initEasyLoginsTable();

        if ($('.expires-time').length) {
            $('.expires-time').each(function () {
                const timer = this;
                const expiresDate = $(this).html();

                // Set the date we're counting down to
                const countDownDate = new Date(expiresDate).getTime();

                // Update the count down every 1 second
                const x = setInterval(() => {
                    // Get todays date and time
                    const now = new Date().getTime();

                    // Find the distance between now an the count down date
                    const distance = countDownDate - now;

                    // Time calculations for days, hours, minutes and seconds
                    const hours = Math.floor(distance / (1000 * 60 * 60));
                    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    // Display the result in the element with id="demo"
                    $(timer).html(`${hours}h ${minutes}m ${seconds}s `);

                    // If the countdown is finished, write some text
                    if (distance < 0) {
                        clearInterval(x);
                        $(timer).html('EXPIRED');
                    }
                }, 1000);
            });
        }
    };

    const $lessonAssignmentsListTable = $('#lesson-assignments-list-table');
    const $assessmentAssignmentsListTable = $('#assessment-assignments-list-table');

    const initLessonAssignmentsTable = function () {
        $lessonAssignmentsListTable.bootstrapTable({
            formatNoMatches() {
                return 'No assignments to show';
            },
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            pagination: true,
            search: false,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: '/my-profile/lesson-assignments/json/',
            pageSize: 5,
            queryParamsType: 'other',
            queryParams(params) {
                const queryParams = {};
                queryParams.search = params.searchText;
                queryParams.page = params.pageNumber;
                queryParams.pageSize = params.pageSize;
                queryParams.sort = params.sortName;
                queryParams.order = params.sortOrder;

                return queryParams;
            },
            columns: [
                {
                    title: 'Assigned',
                    field: 'date_assigned',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        const newDate = new Date(value);
                        return newDate.toLocaleDateString('en-US');
                    },
                },
                {
                    title: 'Start Date',
                    field: 'date_start',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        if (!value) {
                            return '';
                        }

                        const [year, month, day] = value.slice(0, 10).split('-').map(Number);

                        if (!year || year < 1901) {
                            return '';
                        }

                        return new Date(year, month - 1, day).toLocaleDateString('en-US');
                    },
                },
                {
                    title: 'Cluster',
                    field: 'cluster',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter: (value, row) => `${value} ${row.subtitle ? `<br><em>${row.subtitle}</em>` : ''}`,
                },
                {
                    title: 'Grades',
                    field: 'grade_band',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Completion Type',
                    field: 'completion_type',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Assigned To',
                    field: 'number_assigned_to',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter: (value, row) => {
                        const assignmentViewUrl = $lessonAssignmentsListTable
                            .data('view-url')
                            .replace(':lesson_id', row.lesson_id)
                            .replace(':assignment_id', row.assignment_id);

                        return `
                            <a href="${assignmentViewUrl}" class="btn btn-hollow-dark-gray">
                                ${value} student${+value !== 1 ? 's' : ''}
                            </a>
                        `;
                    },
                },
                {
                    title: '% Completed',
                    field: 'percentage_completed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter: (value) => `${Math.round(value * 100) / 100}%`,
                },
                {
                    title: 'Actions',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter: (value, row) => {
                        const assignmentViewUrl = $lessonAssignmentsListTable
                            .data('view-url')
                            .replace(':lesson_id', row.lesson_id)
                            .replace(':assignment_id', row.assignment_id);
                        const assignmentEditUrl = row.locked === '1'
                            ? '#'
                            : $lessonAssignmentsListTable
                                .data('edit-url')
                                .replace(':lesson_id', row.lesson_id)
                                .replace(':assignment_id', row.assignment_id);
                        const assignmentDeleteUrl = $lessonAssignmentsListTable
                            .data('delete-url')
                            .replace(':lesson_id', row.lesson_id)
                            .replace(':assignment_id', row.assignment_id);

                        const lockedButtonAttributes = row.locked === '1'
                            ? 'disabled title="This assignment cannot be edited because it is being managed automatically."'
                            : '';

                        return `
                            <a href="${assignmentViewUrl}" class="btn btn-hollow-green">View</a>
                            ${
                                !row.can_manage
                                    ? ''
                                    : `
                                <a href="${assignmentEditUrl}" class="btn btn-hollow-blue" ${lockedButtonAttributes}>Edit</a>
                                <form action="${assignmentDeleteUrl}" method="post" class="delete-entry">
                                    <input type="hidden" name="csrf_token" value="${Jr.getCsrfToken()}">
                                    <input type="hidden" name="_METHOD" value="DELETE"/>
                                    <button type="submit" class="btn btn-hollow-pink" ${lockedButtonAttributes}>Delete</button>
                                </form>
                            `
                            }
                        `;
                    },
                },
            ],
            responseHandler(res) {
                $('#number_of_lesson_assignments').html(res.meta.total);
                $lessonAssignmentsListTable.closest('.light-blur').removeClass('light-blur');
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                return formattedResult;
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
            },
            onLoadError(status) {
                console.error('Failed to load lesson assignments', status);
                $lessonAssignmentsListTable.closest('.light-blur').removeClass('light-blur');
            },
            rowStyle(row) {
                let classes = '';

                if (row.percentage_completed < 33.3333) {
                    classes += 'danger ';
                } else if (row.percentage_completed < 66.6666) {
                    classes += 'warning ';
                } else if (row.percentage_completed < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
        });
    };

    const initAssessmentAssignmentsTable = function () {
        $assessmentAssignmentsListTable.bootstrapTable({
            formatNoMatches() {
                return 'No assignments to show';
            },
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            pagination: true,
            search: false,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: '/my-profile/assessment-assignments/json/',
            pageSize: 5,
            queryParamsType: 'other',
            queryParams(params) {
                const queryParams = {};
                queryParams.search_term = params.searchText;
                queryParams.page = params.pageNumber;
                queryParams.page_size = params.pageSize;
                queryParams.order_by = params.sortName;
                queryParams.sort_order = params.sortOrder;

                return queryParams;
            },
            columns: [
                {
                    title: 'Assigned',
                    field: 'date_assigned',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        const newDate = new Date(value);

                        return newDate.toLocaleDateString('en-US');
                    },
                },
                {
                    title: 'Start Date',
                    field: 'start_date',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        if (!value) {
                            return '';
                        }

                        const [year, month, day] = value.slice(0, 10).split('-').map(Number);

                        if (!year || year < 1901) {
                            return '';
                        }

                        return new Date(year, month - 1, day).toLocaleDateString('en-US');
                    },
                },
                {
                    title: 'Assigned To',
                    field: 'number_assigned_to',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter: (value, row) => {
                        const assignmentViewUrl = $assessmentAssignmentsListTable
                            .data('view-url')
                            .replace(':assessment_id', row.assessment_id)
                            .replace(':assignment_id', row.assignment_id);

                        return `
                            <a href="${assignmentViewUrl}" class="btn btn-hollow-dark-gray">
                                ${value} student${+value !== 1 ? 's' : ''}
                            </a>
                        `;
                    },
                },
                {
                    title: '% Completed',
                    field: 'percentage_completed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter: (value) => `${Math.round(value * 100) / 100}%`,
                },
                {
                    title: 'Actions',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter: (value, row) => {
                        const assignmentViewUrl = $assessmentAssignmentsListTable
                            .data('view-url')
                            .replace(':assessment_id', row.assessment_id)
                            .replace(':assignment_id', row.assignment_id);
                        const assignmentEditUrl = $assessmentAssignmentsListTable
                            .data('edit-url')
                            .replace(':assessment_id', row.assessment_id)
                            .replace(':assignment_id', row.assignment_id);
                        const assignmentDeleteUrl = $assessmentAssignmentsListTable
                            .data('delete-url')
                            .replace(':assessment_id', row.assessment_id)
                            .replace(':assignment_id', row.assignment_id);

                        return `
                            <a href="${assignmentViewUrl}" class="btn btn-hollow-green">View</a>
                            ${
                                !row.can_manage
                                    ? ''
                                    : `
                                <a href="${assignmentEditUrl}" class="btn btn-hollow-blue">Edit</a>
                                <form action="${assignmentDeleteUrl}" method="post" class="delete-entry">
                                    <input type="hidden" name="csrf_token" value="${Jr.getCsrfToken()}">
                                    <input type="hidden" name="_METHOD" value="DELETE"/>
                                    <button type="submit" class="btn btn-hollow-pink">Delete</button>
                                </form>
                            `
                            }
                        `;
                    },
                },
            ],
            responseHandler(res) {
                $('#number_of_assessment_assignments').html(res.meta.total);
                $assessmentAssignmentsListTable.closest('.light-blur').removeClass('light-blur');

                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                return formattedResult;
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
            },
            onLoadError(status) {
                console.error('Failed to load assessment assignments', status);
                $assessmentAssignmentsListTable.closest('.light-blur').removeClass('light-blur');
            },
            rowStyle(row) {
                let classes = '';

                if (row.percentage_completed < 33.3333) {
                    classes += 'danger ';
                } else if (row.percentage_completed < 66.6666) {
                    classes += 'warning ';
                } else if (row.percentage_completed < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
        });
    };

    const $userListTable = $('#user-list-table');
    const initStudentsTable = function () {
        $userListTable.bootstrapTable({
            formatNoMatches() {
                return 'No students logged in currently.';
            },
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            pagination: false,
            search: false,
            sortName: 'date_last_activity',
            sortOrder: 'desc',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: '/users/json/',
            pageSize: 10,
            queryParamsType: 'other',
            queryParams(params) {
                const queryParams = {};
                queryParams.search_term = params.searchText;
                queryParams.page = params.pageNumber;
                queryParams.page_size = params.pageSize;
                queryParams.order_by = params.sortName;
                queryParams.sort_order = params.sortOrder;
                queryParams.logged_in = 1;
                queryParams.user_type = [2];

                return queryParams;
            },
            columns: [
                {
                    title: 'Role',
                    field: 'role',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        switch (row.role_id_out) {
                            case 2:
                                return `<i class="fa fa-child" aria-hidden="true"></i> ${row.role_name}`;
                            case 3: // teacher
                                return `<i class="fa fa-user text-success" aria-hidden="true"></i> ${row.role_name}`;
                            case 4: // school admin
                                return `<i class="fa fa-user text-info" aria-hidden="true"></i> ${row.role_name}`;
                            case 5: // district admin
                                return `<i class="fa fa-user text-warning" aria-hidden="true"></i> ${row.role_name}`;
                            case 6: // vjs admin
                                return `<i class="fa fa-user text-danger" aria-hidden="true"></i> ${row.role_name}`;
                            case 7:
                                return `<i class="fa fa-laptop" aria-hidden="true"></i> ${row.role_name}`;
                            default:
                                return value;
                        }
                    },
                },
                {
                    title: 'User',
                    field: 'user',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        let user = row.username_out;
                        if (row.first_name_out != null && row.last_name_out != null) {
                            user += ` [${row.first_name_out} ${row.last_name_out}]`;
                        }

                        return user;
                    },
                },
                {
                    title: 'Last Login',
                    field: 'date_last_login',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: Jr.Utils.dateSorter,
                    formatter(value) {
                        return Jr.Utils.convertDate(value, 'llll');
                    },
                },
                {
                    title: 'Last Activity',
                    field: 'date_last_activity',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: Jr.Utils.dateSorter,
                    formatter(value) {
                        return Jr.Utils.convertDate(value, 'llll');
                    },
                },
            ],
            onLoadSuccess(data) {
                $('time.timeago').timeago();
                $('#number_logged_in').html(data.total);
                $userListTable.closest('.light-blur').removeClass('light-blur');
            },
            onLoadError(status) {
                console.error('Failed to load logged-in students', status);
                $userListTable.closest('.light-blur').removeClass('light-blur');
            },
            responseHandler(res) {
                const formattedResult = {};

                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;
                formattedResult.duration = res.meta.duration;
                return formattedResult;
            },
            rowStyle(row) {
                const classes = row.logged_in_out && 'success';

                return {
                    classes,
                };
            },
        });
    };

    const $easyloginListTable = $('#easy-logins-table');
    const initEasyLoginsTable = function () {
        const columns = [
            {
                title: 'Code',
                field: 'code',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value, row) {
                    return `<span>${row.code}</span>`;
                },
            },
            {
                title: 'Label',
                field: 'label',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Expires',
                field: 'date_expires',
                align: 'left',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    return value == null ? 'Never' : value;
                },
            },
            {
                title: 'Students',
                field: 'easy_login_students_count',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Actions',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                formatter(value, row) {
                    let actions = '';

                    if (row.can_manage) {
                        const easyLoginEditUrl = $easyloginListTable.data('easy-login-edit-url').replace(':easy_login_code', row.code);
                        const easyLoginDeleteUrl = $easyloginListTable
                            .data('easy-login-delete-url')
                            .replace(':easy_login_id', row.easy_login_id);

                        actions = `
                            <a href="${easyLoginEditUrl}" class="btn btn-hollow-blue">Edit</a>
                            <form action="${easyLoginDeleteUrl}" method="post" class="delete-entry">
                                <input type="hidden" name="csrf_token" value="${Jr.getCsrfToken()}">
                                <input type="hidden" name="_METHOD" value="DELETE"/>
                                <button type="submit" class="btn btn-hollow-pink">Delete</button>
                            </form>
                        `;
                    }

                    return actions;
                },
            },
        ];

        $easyloginListTable.bootstrapTable({
            formatNoMatches() {
                return 'No EasyLogins to show';
            },
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'code',
            minimumCountColumns: '2',
            pagination: false,
            search: false,
            sortName: 'date_created',
            sortOrder: 'desc',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: '/easy-logins/json/',
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const queryParams = {};
                queryParams.search_term = params.searchText;
                queryParams.page = params.pageNumber;
                queryParams.page_size = params.pageSize;
                queryParams.order_by = params.sortName;
                queryParams.sort_order = params.sortOrder;

                return queryParams;
            },
            columns,
            responseHandler(res) {
                const formatted = {};
                formatted.total = res.meta.total;
                formatted.rows = res.data;

                return formatted;
            },
            onLoadSuccess(data) {
                $('time.timeago').timeago();
                $('#number_easy_logins').html(data.total);
                $easyloginListTable.closest('.light-blur').removeClass('light-blur');
            },
            onLoadError(status) {
                console.error('Failed to load easy logins', status);
                $easyloginListTable.closest('.light-blur').removeClass('light-blur');
            },

            rowStyle(row) {
                let classes = '';

                if (row.authentication_token) {
                    classes += 'success ';
                }
                if (row.is_active === 0) {
                    classes += 'danger ';
                }

                return {
                    classes,
                };
            },
        });
    };

    return my;
}(Postlogin || {}));
